import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";
import logo from "application/BiblioBoard_Logo_Stacked.png";

import {
  Redirect,
  Route,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import withAuthorization from "../auth/withAuthorization";
import UserBrowseView from "./UserBrowseView";
import UserEditView from "./UserEditView";
import { useUsers } from "./userServices";
import { notBlank } from "../util/ext";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },

  tabs: {
    minHeight: 50,
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
  },

  tabsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
  },

  tab: {
    fontSize: "1.3rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    minHeight: 40,
    minWidth: 100,
    color: theme.palette.primary.darker,
    borderRadius: 50,
    "&:hover": {
      color: theme.palette.primary.darker,
    },
  },

  selectedTab: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 50,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  },

  link: {
    color: "inherit",
  },

  creatorLogo: {
    width: "100%",
    height: "100%",
  },
}));

const AuthorizedRoute = withAuthorization(Route);

const UserAdminView = () => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const history = useHistory();
  const { state = {} } = useLocation();

  const initialSearchState = {
    appliedFilter: [],
    appliedOrganization: state.organizationId,
    orderBy: "accountName",
    orderDirection: "asc",
    roles: [],
    activeOnly: false,
    page: 0,
  };

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useUsers(
    searchState.appliedFilter,
    searchState.roles,
    searchState.appliedOrganization,
    `${searchState.orderBy}:${searchState.orderDirection}`,
    searchState.activeOnly,
    searchState.page,
  );

  return (
    <Container
      id="user-admin-application"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <ApplicationHeader
        applicationLogo={
          <img
            className={classes.creatorLogo}
            alt="User Administration"
            src={logo}
          />
        }
        applicationNavigationWidth="33%"
      />

      <AuthorizedRoute exact path={`${path}/users`} roles={["ROLE_ADMIN"]}>
        <ApplicationPanel id="application-panel-users">
          <UserBrowseView
            searchState={searchState}
            onSearchStateChange={state => setSearchState(state)}
            searchResults={searchResults}
          />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute
        exact
        path={`${path}/users/:userId`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-user">
          <UserEditView
            onCancel={location =>
              history.push(notBlank(location) ? location : `${path}/users`)
            }
          />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute
        exact
        path={`${path}/users/new-project`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-new-user">
          <div>New User</div>
          {/*<ProjectEdit onCancel={() => history.push(`${path}/users`)} />*/}
        </ApplicationPanel>
      </AuthorizedRoute>

      <Route exact path={path}>
        <Redirect to={`${path}/users`} />
      </Route>
    </Container>
  );
};

export default UserAdminView;
